import { render, staticRenderFns } from "./PurchaseSuccess.vue?vue&type=template&id=50c2c9de"
import script from "./PurchaseSuccess.vue?vue&type=script&lang=js"
export * from "./PurchaseSuccess.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSuccess.vue?vue&type=style&index=0&id=50c2c9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports